/**************************************************************************************************/
/*   File: /src/app/stores/reducers/download/reducer.ts                                           */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri May 24 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as _ from 'lodash';

import * as fromShared from '../../../shared';
import * as fromActions from '../../actions';
import * as fromStates from '../../states';

/**
 * the download state reducer
 * @param state The state
 * @param action The action
 */
export function downloadReducer(
  state: fromStates.fromDownload.DownloadState = fromStates.fromDownload.INITIAL_DOWNLOAD_STATE,
  action: fromActions.fromDownload.DownloadActions |
    fromActions.fromMessages.MessagesActions |
    any): fromStates.fromDownload.DownloadState {

  switch (action.type) {
    /**
    * Selected plan type reducer
    */
    case fromActions.fromDownload.DownloadActionsType.SELECT_PLAN_TYPE:
      return {
        ...state,
        dossierContent: {
          ...fromStates.fromDownload.INITIAL_DOWNLOAD_STATE.dossierContent,
          planCode: action.payload.planCode,
          territorialAreasCodes: []
        }
      };
    /**
     * Selected plan type reducer
     */
    case fromActions.fromDownload.DownloadActionsType.ADD_AMBITO:
      let previousAmbiti = [];
      if (state.dossierContent !== undefined) {
        previousAmbiti = state.dossierContent.territorialAreasCodes;
      }
      return {
        ...state,
        dossierContent: {
          ...state.dossierContent,
          territorialAreasCodes: [
            ...previousAmbiti,
            action.payload.ambitoCode
          ]
        }
      };

    // Remove ambito reducer
    case fromActions.fromDownload.DownloadActionsType.REMOVE_AMBITO:
      return {
        ...state,
        dossierContent: {
          ...fromStates.fromDownload.INITIAL_DOWNLOAD_STATE.dossierContent,
          planCode: state.dossierContent.planCode,
          territorialAreasCodes: state.dossierContent.territorialAreasCodes.filter(x => x !== action.payload.ambitoCode)
        }
      };

    /**
     * Selected plan type reducer
     */
    case fromActions.fromDownload.DownloadActionsType.SELECT_GEO_FILE_TYPE:
      return {
        ...state,
        dossierContent: {
          ...state.dossierContent,
          defaultSpatialDataType: action.payload.defaultSpatialDataType
        }
      };
    /**
     * Rehydrate dossier content
     */
    case fromActions.fromDownload.DownloadActionsType.REHYDRATE_DOSSIER_CONTENT:
      return {
        ...state,
        dossierContent: {
          ...action.payload.dossierContent
        }
      };
    case fromActions.fromDownload.DownloadActionsType.SELECT_GEOMETRIES:
      console.log('The payload is', action.payload);
      return {
        ...state,
        isPreparingSpatial: false,
        isPreparingPublic: false,
        features: _.concat([], action.payload)
      };

    case fromActions.fromDownload.DownloadActionsType.RESET_GEOMETRIES:

      return {
        ...state,
        isPreparingSpatial: false,
        isPreparingPublic: false,
        features: [],
        dossierContent: {
          ...state.dossierContent,
          defaultSpatialDataType: undefined
        }
      };
    case fromActions.fromDownload.DownloadActionsType.PREPARE_GEOMETRIC_DOWNLOAD:
      console.log('Prepare download reducer');
      return {
        ...state,
        isPreparingSpatial: true,
        isReady: false,
        taskId: undefined
      };

    case fromActions.fromDownload.DownloadActionsType.PREPARE_GEOMETRIC_DOWNLOAD_SUCCESS:
      console.log('Prepare download reducer', action.payload);
      return {
        ...state,
        taskId: action.payload.taskId
      };
    case fromActions.fromDownload.DownloadActionsType.PREPARE_GEOMETRIC_DOWNLOAD_FAIL:
      console.log('Prepare download reducer', action.payload);
      return {
        ...state,
        isPreparingSpatial: false,
        isReady: false,
        taskId: undefined,
        messages: [
          action.payload.message
        ]
      };
    case fromActions.fromDownload.DownloadActionsType.PREPARE_REGULATIONS_DOWNLOAD:
      return {
        ...state,
        isPreparingRegulations: true,
        isReady: false,
      };
    case fromActions.fromDownload.DownloadActionsType.PREPARE_REGULATIONS_DOWNLOAD_FAIL:
      return {
        ...state,
        isPreparingRegulations: false,
        isReady: false,
        messages: [
          action.payload.message
        ]
      };
    case fromActions.fromDownload.DownloadActionsType.PREPARE_REGULATION_FOR_AMBITO_DOWNLOAD:
      return {
        ...state,
        isPreparingRegulations: true,
        regulationsResponse: [],
        isReady: false
      };
    case fromActions.fromDownload.DownloadActionsType.PREPARE_REGULATION_FOR_AMBITO_DOWNLOAD_SUCCESS:
      return {
        ...state,
        isPreparingRegulations: state.regulationsResponse.length === state.dossierContent.territorialAreasCodes.length,
        regulationsResponse: [
          ...state.regulationsResponse,
          action.payload.regulationResponse
        ],
        isReady: false
      };
    case fromActions.fromDownload.DownloadActionsType.PREPARE_REGULATION_FOR_AMBITO_DOWNLOAD_FAIL:
      return {
        ...state,
        isPreparingRegulations: false,
        isReady: false,
        regulationsResponse: [],
        messages: [
          action.payload.message
        ]
      };
    case fromActions.fromDownload.DownloadActionsType.CHECK_DOWNLOAD_STATUS:
      console.log('Prepare download reducer');
      return {
        ...state,
        isPreparingSpatial: true
      };

    case fromActions.fromDownload.DownloadActionsType.CHECK_DOWNLOAD_STATUS_SUCCESS:
      console.log('Prepare download reducer', action.payload);
      return {
        ...state,
        isPreparingSpatial: !action.payload.completed,
        isReady: action.payload.completed && !state.isPreparingPublic && !state.isPreparingRegulations
      };
    case fromActions.fromDownload.DownloadActionsType.CHECK_DOWNLOAD_STATUS_FAIL:
      console.log('Prepare download reducer', action.payload);
      return {
        ...state,
        isPreparingSpatial: false,
        isReady: false,
        taskId: undefined,
        messages: [
          action.payload.message
        ]
      };
    case fromActions.fromDownload.DownloadActionsType.LOAD_PUBLIC_DOCUMENT:
      return {
        ...state,
        isPreparingPublic: true,
        publicDocuments: []
      };
    case fromActions.fromDownload.DownloadActionsType.LOAD_PUBLIC_DOCUMENT_SUCCESS:
      return {
        ...state,
        isPreparingPublic: false,
        publicDocuments: [
          ...action.payload.documents
        ]
      };
    case fromActions.fromDownload.DownloadActionsType.LOAD_PUBLIC_DOCUMENT_FAIL:
      return {
        ...state,
        isPreparingPublic: false,
        publicDocuments: [],
        messages: [
          action.payload.message
        ]
      };

    case fromActions.fromDownload.DownloadActionsType.RESET_DOWNLOAD_STATE:
      return {
        ...fromStates.fromDownload.INITIAL_DOWNLOAD_STATE
      };

    case fromActions.fromMessages.MessagesActionsType.REMOVE_MESSAGE_ACTION:
      return {
        ...state,
        messages: [...state.messages.filter(x => x !== action.payload.message)]
      };
    // Reducer for load the ambiti
    case fromActions.fromDownload.DownloadActionsType.LOAD_AMBITI_BY_PLAN:
      return {
        ...state,
        isLoading: true,
        ambiti: [],
        messages: []
      };
    // Reducer for ambiti success
    case fromActions.fromDownload.DownloadActionsType.LOAD_AMBITI_BY_PLAN_SUCCESS:
      if (!action.payload.ambiti || action.payload.ambiti.length === 0) {
        return {
          ...state,
          isLoading: false,
          ambiti: [],
          messages: [
            new fromShared.models.Message(
              fromShared.enums.MessageType.ERROR,
              fromShared.enums.Messages.NO_AMBITI_FOR_PLAN,
              fromShared.enums.MessagePositionEnum.TOP,
              fromStates.fromUi.STATE_NAME
            )
          ]
        };
      }
      return {
        ...state,
        isLoading: false,
        ambiti: action.payload.ambiti
      };
    // Reducer for ambiti fail
    case fromActions.fromDownload.DownloadActionsType.LOAD_AMBITI_BY_PLAN_FAIL:
      return {
        ...state,
        isLoading: false,
        ambiti: [],
        messages: [
          action.payload.message
        ]
      };

    // Reducer for notify message
    case fromActions.fromMessages.MessagesActionsType.NOTIFY_MESSAGE:
      return action.payload.message.stateName === fromStates.fromDownload.STATE_NAME ?
        {
          ...state,
          messages: [
            ...state.messages,
            action.payload.message
          ]
        } : { ...state };
    // Reducer for unset user
    case fromActions.fromUi.UiActionTypes.UNSET_LOGGED_USER:
      return {
        ...fromStates.fromDownload.INITIAL_DOWNLOAD_STATE
      };
    default:
      return state;
  }
}

// Helpers
/**
 * The get isLoading helper function
 * @param state The state
 */
const getIsLoading = (state: fromStates.fromDownload.DownloadState) => state.isLoading;
/**
 * The get features helper function
 * @param state The state
 */
const getFeatures = (state: fromStates.fromDownload.DownloadState) => state.features;
/**
 * The get feature selected helper function
 * @param state The state
 */
const getFeatureSelected = (state: fromStates.fromDownload.DownloadState) => state.features.length > 0;
/**
 * The get isPreparing helper function
 * @param state The state
 */
const getIsPreparing = (state: fromStates.fromDownload.DownloadState) => state.isPreparingSpatial || state.isPreparingPublic || state.isPreparingRegulations;
/**
 * The get isReady helper function
 * @param state The state
 */
const getIsReady = (state: fromStates.fromDownload.DownloadState) => state.isReady;
/**
 * The get messages helper function
 * @param state The state
 */
const getMessages = (state: fromStates.fromDownload.DownloadState) => state.messages;
/**
 * Get the dossier content
 * @param state The state
 */
const getDossierContent = (state: fromStates.fromDownload.DownloadState) => state.dossierContent;
/**
 * Get the ambiti
 * @param state The state
 */
const getAmbiti = (state: fromStates.fromDownload.DownloadState) => state.ambiti;
/**
 * Get the task id
 * @param state The state
 */
const getTaskId = (state: fromStates.fromDownload.DownloadState) => state.taskId;
/**
 * Get the public documents
 * @param state The state
 */
const getPublicDocuments = (state: fromStates.fromDownload.DownloadState) => state.publicDocuments;
/**
 * Get the regulations response
 * @param state The state
 */
const getRegulationsResponse = (state: fromStates.fromDownload.DownloadState) => state.regulationsResponse;
/**
 * Export the helpers
 */
export const helpers = {
  getIsLoading,
  getFeatures,
  getFeatureSelected,
  getIsPreparing,
  getIsReady,
  getMessages,
  getDossierContent,
  getAmbiti,
  getTaskId,
  getPublicDocuments,
  getRegulationsResponse
};
